import React, { useState } from "react";
import { CheckLabel, CopyHash, IconButton } from "@sscs/ui";
import { ChevronDownIcon, ChevronUpIcon } from "@sscs/ui/icons";
import { getDateFromISOString, humanReadableBytes, transformScanDuration, } from "@sscs/utils";
import { formatDistanceToNowStrict } from "date-fns";
import { REPORT_PAGES_ROUTES } from "../../../constants";
import { getFileName, getSha256 } from "../../../utils";
import { LinkToReportTab } from "../../common";
import styles from "./fileCard.module.scss";
const FileCard = ({ releaseStatus, fileInfo, scanLevel, isLevelCustomized, isReproducibilityCheck, isDiffCheck, scanTimestamp, scanDuration, onClick, }) => {
    const [showSummary, setShowSummary] = useState(true);
    let to = REPORT_PAGES_ROUTES.ISSUES_ROUTE;
    if (isReproducibilityCheck) {
        to = REPORT_PAGES_ROUTES.REPRODUCIBILITY_ROUTE;
    }
    else if (isDiffCheck) {
        to = REPORT_PAGES_ROUTES.VERSION_DIFF;
    }
    const fileTypeInfo = `${fileInfo.type}/${fileInfo.subtype}${fileInfo.format ? `/${fileInfo.format}` : ""}`;
    const sha256 = getSha256(fileInfo);
    const scanDate = scanTimestamp ? getDateFromISOString(scanTimestamp) : null;
    return (React.createElement("div", { className: styles.card },
        React.createElement(LinkToReportTab, { underline: "none", id: "pass-fail-large-icon", to: to, "aria-label": "CI/CD status", onClick: onClick, className: styles["pill-link"] },
            React.createElement(CheckLabel, { className: styles.pill, status: releaseStatus, scanLevel: scanLevel, isLevelCustomized: isLevelCustomized, isReproducibilityCheck: isReproducibilityCheck, isDiffCheck: isDiffCheck })),
        showSummary && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles["file-block"] },
                React.createElement("div", { className: styles["file-name"] }, getFileName(fileInfo)),
                React.createElement("div", { className: styles["file-meta"], title: fileTypeInfo },
                    fileTypeInfo,
                    " \u00B7 ",
                    humanReadableBytes(Number(fileInfo.size))),
                sha256 && (React.createElement("div", { className: styles["sha-line"] },
                    React.createElement("span", null, "SHA256"),
                    React.createElement("span", { className: styles["sha-value"], title: sha256 }, sha256),
                    React.createElement(CopyHash, { id: "summary-copy-hash-to-clipboard", sha256: sha256 })))),
            scanDate && (React.createElement("div", { className: styles["scan-meta"] },
                "Scanned ",
                formatDistanceToNowStrict(scanDate, { addSuffix: true }),
                scanDuration ? ` · ${transformScanDuration(scanDuration)}` : "")))),
        React.createElement(IconButton, { id: "file-card-toggle-summary", size: "small", onClick: () => setShowSummary(!showSummary), "aria-label": showSummary ? "hide summary" : "show summary", className: styles["toggle-summary"] }, showSummary ? (React.createElement(ChevronUpIcon, { size: "xs", color: "disabled" })) : (React.createElement(ChevronDownIcon, { size: "xs", color: "disabled" })))));
};
export default FileCard;
//# sourceMappingURL=FileCard.js.map